<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Swal from "sweetalert2";
import Box from "../component/boxperfil";

export default {
    components: { Layout, PageHeader, Swal, Box },
    data() {
        return {
            title: "Inventario",
            items: [
                {

                    text: "Inicio",
                    href: "/"
                },
                {
                    text: "Inventario",
                    active: true
                }
            ],
            totalRows: 1,
            currentPage: 1,
            perPage: 100,
            pageOptions: [100],
            filter: null,
            filterOn: [],
            sortBy: "name",
            sortDesc: false,
            fields: [
                { key: "name", label: "NOMBRE", sortable: true },
                { key: "medida", label: "Medida", sortable: true },
                { key: "stock_minimo", label: "STOCK MINIMO", sortable: true },
                //{ key: "fecha_vencimiento", label: "Vencimiento", sortable: true },
                // { key: "numero_de_lote", label: "Lote", sortable: true }
            ],
            historial_fields: [
                { key: "tipo", label: "TIPO", sortable: true },
                { key: "cantidad", label: "CANTIDAD", sortable: true },
                { key: "motivo", label: "MOTIVO", sortable: true },
                { key: "created_at", label: "FECHA", sortable: true },
            ],
            inventario: '',
            articulos: [],
            articulo: {
                name: "",
                barra: "",
                sku: "",
                marca_id: '',
                medida_id: '',
                categoria_id: '',
                tipo_id: '',
                ubicacion_id: '',
                laboratorio_id: '',
                fecha_vencimiento: '',
                venta: '',
                porcion: 1,
                es_producto: true,
                numero_de_lote: '',
                stock_minimo: 1,
                stock_inicial: 1,
            },
            stock: {
                articulo: {},
                articulo_id: '',
                motivo: '',
                cliente_id: '',
                cantidad: 1,
                max: 1000,
                tipo: '1',
            },
            stock_boton: false,
            marcas: [],
            medidas: [],
            tipos: [],
            categorias: [],
            ubicaciones: [],
            clientes: [],
            laboratorios: [],
            temperaturas: [],
            users: [],
            isLoading: false,
            fileproductos: null,
            buttonDisabled: true,
            showError: false,
            producto_nuevo: false,
            historial: [],
            windowWidth: window.innerWidth,
            windowHeight: window.innerHeight,
            precio_kilo:0
        };
    },
    methods: {
        formatearFecha(fecha) {
            fecha = new Date(fecha);
            // Formatear la fecha como deseado (por ejemplo: DD/MM/YYYY HH:mm:ss)
            const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit' };
            return fecha.toLocaleDateString('es-ES', options).replace(/,/g, '');

        },
        formatearCantidadHistorial(item) {
            const cantidad = parseFloat(item?.cantidad) || 0;
            const medidaNombre = this.historial?.medida?.name || '';

            if (medidaNombre == 'Kilogramo - Gramos') {
                if (Math.abs(cantidad) < 1) {
                    return `${(cantidad * 1000).toFixed(0)} gr`;
                }
                return `${cantidad.toFixed(3).replace(/\.000$/, '')} kg`;
            }

            if (medidaNombre == 'Litros - Mililitros') {
                if (Math.abs(cantidad) < 1) {
                    return `${(cantidad * 1000).toFixed(0)} ml`;
                }
                return `${cantidad.toFixed(3).replace(/\.000$/, '')} L`;
            }

            return `${cantidad.toFixed(3).replace(/\.000$/, '')} ${this.historial?.medida?.codigo || ''}`.trim();
        },
        bloquearNoNumeros(e) {
            const code = e.charCode || e.keyCode
            if (code < 48 || code > 57) {
            e.preventDefault()
            }
        },
        normalizarCantidad(cantidad) {
            if (cantidad === null || cantidad === undefined) return 0;
            const valor = ('' + cantidad).replace(',', '.').trim();
            return parseFloat(valor);
        },
        unidadMayorStock() {
            const medidaNombre = this.medidas.find(m => m.id == this.stock?.articulo?.medida_id)?.name;
            if (medidaNombre == 'Kilogramo - Gramos') return 'kg';
            if (medidaNombre == 'Litros - Mililitros') return 'L';
            if (medidaNombre == 'Unidad') return 'unidades';
            return medidaNombre || 'unidad base';
        },
        codigoMedidaStock(medida) {
            const codigo = (medida?.codigo || '').trim();
            return codigo.toLowerCase() == 'l' ? 'L' : codigo;
        },
        ayudaCantidadStock() {
            const medidaNombre = this.medidas.find(m => m.id == this.stock?.articulo?.medida_id)?.name;
            if (medidaNombre == 'Kilogramo - Gramos') return 'Ingresa en kg (ej: 9.5 kg = 9500 gr)';
            if (medidaNombre == 'Litros - Mililitros') return 'Ingresa en litros (ej: 1.5 L = 1500 ml)';
            return '';
        },
        formatearMiles(campo) {
            const valor = this.articulo[campo].replace(/\D/g, '')
            this.articulo[campo] = valor.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },
        validarCantidad() {
            const cantidad = this.normalizarCantidad(this.stock.cantidad);
            if (isNaN(cantidad) || cantidad <= 0) {
                this.stock_boton = true
            } else {
                this.stock_boton = false
            }
        },
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },
        get_data() {
            this.isLoading = true
            axios.get('/api/inventarios').then(res => {
                this.articulos = res.data.datos;
                this.marcas = res.data.marcas;
                this.medidas = res.data.medidas;
                this.ubicaciones = res.data.ubicaciones;
                this.tipos = res.data.tipos;
                this.categorias = res.data.categorias;
                this.clientes = res.data.clientes;
                this.laboratorios = res.data.laboratorios;
                this.temperaturas = res.data.temperaturas;
                this.users = res.data.users;
                this.isLoading = false

                this.fields.push({ key: "stock", label: "STOCK", sortable: false })
                this.fields.push({ key: "actions", label: "ACCIONES", sortable: false })
                console.log(this.articulos)
                this.$toasted.success('Datos cargados!');
                this.totalRows = this.articulos.length;
            }).catch(error => {
                console.error('Error fetching data:', error);
                this.error = error;
            }).finally(() => {
                this.isLoading = false;
            });
        },
        ver_modal_producto(tipo, articulo) {
            if (tipo == 'nuevo') {
                this.producto_nuevo = true;
                this.articulo.name = "";
                this.articulo.barra = "";
                this.articulo.sku = "";
                this.articulo.marca_id = '';
                this.articulo.medida_id = '';
                this.articulo.categoria_id = '';
                this.articulo.tipo_id = '';
                this.articulo.ubicacion_id = '';
                this.articulo.laboratorio = '';
                this.articulo.porcion = 1;
                this.articulo.venta = '';
                this.articulo.es_producto = true;
                this.articulo.stock_minimo = 5;
                this.articulo.stock_inicial = 1;
            } else if(tipo == 'clonar') {
                this.producto_nuevo = true;
                this.articulo = { ...articulo, fecha_vencimiento: '',stock_inicial : 1, numero_de_lote: '' };
                this.articulo.stock_minimo = parseInt(articulo.stock_minimo)
            }
            this.$refs['modal_producto'].show();
        },
        update_producto() {
            if (this.articulo.name != "") {
                this.isLoading = true
                axios.put('/api/articulos/' + this.articulo.id, this.articulo).then(res => {
                    if (res.data.estado) {
                        this.articulo = res.data.articulo
                        this.get_data()
                    } else {
                        Swal.fire({
                            //position: "top-end",
                            icon: "warning",
                            title: "Error al agregar",
                            text: '',
                            showConfirmButton: true,
                            timer: 5000
                        });
                    }
                    this.isLoading = false
                })
            } else {
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "Nombre invalido",
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                }).then((result) => {
                    this.$refs['modal_producto'].show();
                })
            }
        },
        guardar_producto() {
            if (this.articulo.name != "") {
                this.isLoading = true
                axios.post('/api/articulos', this.articulo).then(res => {
                    if (res.data.estado) {
                        this.articulo = res.data.articulo
                        this.get_data()
                    } else {
                        Swal.fire({
                            //position: "top-end",
                            icon: "warning",
                            title: "Error al agregar",
                            text: '',
                            showConfirmButton: true,
                            timer: 5000
                        });
                    }
                    this.isLoading = false
                })
            } else {
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "Nombre invalido",
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                }).then((result) => {
                    this.$refs['modal_producto'].show();
                })
            }
        },
        agregar_stock(producto) {
            this.stock = {}
            this.stock_boton = false
            this.stock.articulo = producto;
            this.stock.articulo_id = producto.id;
            this.stock.motivo = '';
            this.stock.cliente_id = '';
            this.stock.cantidad = 1;
            this.stock.max = 99999999;
            this.stock.tipo = '1';

            this.$refs['stock_producto'].show();
        },
        quitar_stock(producto) {
            this.stock = {}
            this.stock_boton = false
            this.stock.articulo = producto
            this.stock.articulo_id = producto.id
            this.stock.motivo = ''
            this.stock.cliente_id = ''
            this.stock.cantidad = 1
            this.stock.max = producto.ingresos - producto.egresos
            this.stock.tipo = '2'

            this.$refs['stock_producto'].show();
        },
        guardar_stock() {
            //console.log(this.stock)
            const cantidad = this.normalizarCantidad(this.stock.cantidad);
            this.stock.cantidad = cantidad;
            if (parseFloat(this.stock.max) < cantidad) {
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "La cantidad supera el stock actual de " + this.stock.max,
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                });
            } else if (!isNaN(cantidad) && isFinite(cantidad) && cantidad > 0) {
                this.isLoading = true
                this.$refs['stock_producto'].hide();
                axios.post('/api/inventarios', this.stock).then(res => {
                    if (res.data.estado) {
                        this.inventario = res.data.inventario
                        this.get_data()
                    } else {
                        Swal.fire({
                            //position: "top-end",
                            icon: "warning",
                            title: "La cantidad no es valida.",
                            text: '',
                            showConfirmButton: true,
                            timer: 5000
                        });
                    }
                    this.isLoading = false
                })
            } else {
                Swal.fire({
                    //position: "top-end",
                    icon: "warning",
                    title: "La cantidad no es valida",
                    text: '',
                    showConfirmButton: true,
                    timer: 5000
                });
            }
        },
        ver_historial(articulo) {
            this.historial = articulo
            this.$refs.historial.show();
        },
        onFileProductosChange(e) {
            this.fileproductos = e.target.files[0];
            this.buttonDisabled = false;
        },
        descargar_formato() {
            let url = '/csv/formato_productos.csv';
            // Abrir una nueva ventana con la URL del archivo
            window.open(url, '_blank');
        },
        uploadCsvArticulos() {
            this.isLoading = true;
            if (this.buttonDisabled) {
                return; // Si está deshabilitado, salir sin hacer nada
            }
            this.buttonDisabled = true;

            let formData = new FormData();
            formData.append('file', this.fileproductos);

            axios.post('/api/upload_csv_articulos', formData).then(res => {
                if (res.data.estado) {
                    this.$refs['csv'].hide();
                    console.log(res.data.mensaje);
                    console.log(res.data.productosCargados);
                    console.log(res.data.productosError);
                    this.get_data()
                    this.isLoading = false;
                }
            }).catch(error => {
                console.error(error);
                this.isLoading = false;
            });

            setTimeout(() => {
                // Volver a habilitar el botón después de algún tiempo (por ejemplo, 3 segundos)
                this.buttonDisabled = false;
            }, 5000);
        },
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.windowHeight = window.innerHeight;
        },
        
    },
    mounted() {
        this.get_data()
    },
    computed: {
        isVacuna() {
            const categoria = this.categorias.find(categoria => categoria.id == this.articulo.categoria_id);
            return categoria ? categoria.name === 'Vacuna' : false;
        },
        isAnti() {
            const categoria = this.categorias.find(categoria => categoria.id == this.articulo.categoria_id);
            return categoria ? categoria.name === 'Antiparasitario' : false;
        },
        isMedicamento() {
            const categoria = this.categorias.find(categoria => categoria.id == this.articulo.categoria_id);
            return categoria ? categoria.name === 'Medicamento' : false;
        },
        rows() {
            return this.totalRows;
        },
        nombre_medida() {
            if (this.articulo.medida_id == null || this.articulo.medida_id == '') {
                return 'No Definido';
            }else {
                const art = this.medidas.find(m => m.id === this.articulo.medida_id);
                if (art.name=='Kilogramo - Gramos'){
                    return 'Kg'
                } else if (art.name=='Litros - Mililitros'){
                    return 'Lt'
                } else if (art.name=='Unidad'){
                    return 'Unid'
                } 
            }
        }
    },
    created(){
        this.handleResize()
    }
};
</script>
<style>
.error-message {
    color: red;
}
</style>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <Box />
        <loading-message v-if="isLoading" />
        <b-modal id="csv" ref="csv" title="Cargar articulos/productos desde CSV" hide-footer header-bg-variant="primary">
            <template #modal-header="{ close }">
                <h5 class="text-white">Cargar articulos/productos desde CSV</h5>
                <div class="text-right">
                    <b-button class="text-white text-right" size="sm" variant="none" @click="close()">
                        <i class="bx bx-x font-size-16"></i>
                    </b-button>
                </div>
            </template>
            <div class="col-12">
                <b-button @click="descargar_formato" :disabled="!buttonDisabled" variant="teal"
                    class="float-right mb-3">
                    <i class="fas fa-download"></i> Descargar Formato CSV
                </b-button>
                <loading-message v-if="isLoading" />
                <div>
                    <b-form-file v-model="fileproductos" :state="Boolean(fileproductos)"
                        placeholder="Selecciona un archivo o arrástralo aquí..."
                        drop-placeholder="Suelta el archivo aquí..." @change="onFileProductosChange"></b-form-file>
                    <p> </p>
                    <b-button @click="uploadCsvArticulos" :disabled="buttonDisabled" variant="primary"
                        class="float-right">Cargar
                        CSV</b-button>
                </div>
            </div>
        </b-modal>
        <b-modal id="modal_producto" ref="modal_producto" ok-title="Guardar" header-bg-variant="primary"
            cancel-title="Cancelar" @ok="producto_nuevo ? guardar_producto() : update_producto()">
            <template #modal-header="{ close }">
                <div class="d-flex justify-content-between align-items-center w-100 py-2">
                    <!-- Título del modal centrado verticalmente -->
                    <h5 class="mb-0 text-white">
                    {{ producto_nuevo ? 'Nuevo Ingrediente/Producto' : 'Copiar Producto' }}
                    </h5>

                    <!-- Botón de cierre alineado a la derecha -->
                    <b-button class="text-white p-0" size="sm" variant="none" @click="close()">
                    <i class="bx bx-x font-size-16"></i>
                    </b-button>
                </div>
            </template>

            <div class="row p-3">
                <div class="col-md-6">
                    <b-form-group id="input-group-1" label="Nombre Ingrediente/Producto" label-for="input-1">
                        <b-form-input id="input-1" name="nombre" v-model="articulo.name" type="text"
                            placeholder="Ingresar Nombre"></b-form-input>
                    </b-form-group>
                </div>
                <div :class="medidas.length > 0 && user.sucursal.categorizaciones.includes('Medidas') ? 'col-md-6' : 'col-md-12'"
                    v-if="medidas.length > 0 && user.sucursal.categorizaciones.includes('Medidas')">
                    <b-form-group id="input-group-1" label="Medida" label-for="input-1">
                        <select class="custom-select" v-model="articulo.medida_id">
                            <option value="">Selecciona una medida</option>
                            <option v-for="(medida, i) in medidas" :label="medida.name" :value="medida.id" :key="i">
                            </option>
                        </select>
                    </b-form-group>
                </div>
                <div class="col-md-6">
                    <b-form-group id="input-group-1" label="Clasificacion" label-for="input-1">
                        <select class="custom-select" v-model="articulo.tipo_id">
                            <option value="">Selecciona una clasificación</option>
                            <option
                                v-for="(tipo, i) in (tipos.filter(t => !t.es_producto).length ? tipos.filter(t => !t.es_producto) : tipos)"
                                :label="tipo.name"
                                :value="tipo.id"
                                :key="i">
                            </option>
                        </select>
                    </b-form-group>
                </div>
                <div class="col-md-3">
                    <b-form-group id="input-group-1" label="Stock minimo" label-for="input-1">
                        <b-form-input id="input-1" type="number" v-model.number="articulo.stock_minimo" min="1" max="" step="1" placeholder="Ingresa el stock minimo" ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3 text-left">
                    <p class="mt-4 pt-2">{{nombre_medida}}</p>
                </div>
                <div class="col-md-3">
                    <b-form-group id="input-group-1" label="Stock inicial" label-for="input-1">
                        <b-form-input id="input-1" type="number" v-model.number="articulo.stock_inicial" min="1" max="100" step="1" placeholder="Ingresa el stock inicial" ></b-form-input>
                    </b-form-group>
                </div>
                <div class="col-md-3 text-left">
                    <p class="mt-4 pt-2">{{nombre_medida}}</p>
                </div>
                <div class="col-md-12">
                    <div class="p-3 rounded border bg-soft-primary w-100">
                        <div class="row mt-3" v-if="articulo.es_producto">
                            <div class="col-md-4">
                                <b-form-group class="mb-2">
                                    <p class="mb-1">
                                        Porción {{"("+nombre_medida+")"}}:
                                    </p>
                                    <b-form-input
                                    type="text"
                                    placeholder="Ingrese Porción"
                                    v-model="articulo.porcion"
                                    @keypress="bloquearNoNumeros"
                                    @input="formatearMiles('porcion')"
                                    class="border border-primary border-1 rounded"
                                    />
                                </b-form-group>
                            </div>
                            <div class="col-md-4">
                                <b-form-group class="mb-2">
                                <p class="mb-1">Precio (Porción):</p>
                                <b-form-input
                                    type="text"
                                    placeholder="Ingrese Valor"
                                    v-model="articulo.venta"
                                    @keypress="bloquearNoNumeros"
                                    @input="formatearMiles('venta')"
                                    class="border border-primary border-1 rounded"
                                />
                                </b-form-group>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <b-modal id="stock_producto" ref="stock_producto" hide-footer header-bg-variant="primary">
            <template #modal-header="{ close }">
                <h5 class="text-white">{{stock.tipo==1? "Agregar ":"Quitar "}}stock de producto</h5>
                <div class="text-right">
                    <b-button class="text-white text-right" size="sm" variant="none" @click="close()">
                        <i class="bx bx-x font-size-16"></i>
                    </b-button>
                </div>
            </template>
            <div class="row justify-content-center">
                <div class="col-md-12 col-lg-12 col-xl-12">
                    <b-form-group id="input-group-1" label="Tipo" label-for="input-1">
                        <select class="custom-select" v-model="stock.tipo" disabled>
                            <option value="1">Ingreso</option>
                            <option value="2">Salida</option>
                        </select>
                    </b-form-group>
                    <b-form-group id="input-group-1" label="Motivo" label-for="input-1">
                        <b-form-input id="input-1" name="motivo" v-model="stock.motivo" type="text"
                            placeholder="Ingresar Motivo"></b-form-input>
                    </b-form-group>
                    <b-form-group id="input-group-122" :label="'Cantidad (en ' + unidadMayorStock() + ')'" label-for="input-122">
                        <b-form-input id="input-122" min="0.001" :max="stock.max" step="0.001" v-model="stock.cantidad" type="number"
                            @input="validarCantidad" placeholder="Cantidad">
                        </b-form-input>
                        <small v-if="ayudaCantidadStock()" class="text-muted">{{ ayudaCantidadStock() }}</small>
                        <div v-if="stock_boton" class="error-message">La cantidad debe ser un número positivo
                            mayor que cero.</div>
                    </b-form-group>
                    <b-form-group id="input-group-1" label="Proveedor/Solicitante (opcional)" label-for="input-1"
                        v-if="clientes.length > 0">
                        <select class="custom-select" v-model="stock.cliente_id">
                            <option value="">Selecciona un cliente</option>
                            <option v-for="(cliente, i) in clientes" :label="cliente.name" :value="cliente.id" :key="i">
                            </option>
                        </select>
                    </b-form-group>

                    <button class="btn btn-primary btn-sm py-2 px-4 btn-block" @click="guardar_stock()"
                        :disabled="stock_boton">
                        Guardar
                    </button>
                    <!-- end row -->
                </div>
                <!-- end col -->
            </div>
        </b-modal>
        <b-modal id="historial" ref="historial" hide-footer header-bg-variant="primary">
            <template #modal-header="{ close }">
                <h5 class="text-white">Historial de {{ historial.name }}</h5>
                <div class="text-right">
                    <b-button class="text-white text-right" size="sm" variant="none" @click="close()">
                        <i class="bx bx-x font-size-16"></i>
                    </b-button>
                </div>
            </template>
            <b-table :items="historial.inventarios" :fields="historial_fields" bordered striped>
                <template #cell(tipo)="data">
                    {{ data.item.tipo == 1 ? 'Entrada' : 'Salida' }}
                </template>
                <template #cell(cantidad)="data">
                    {{ formatearCantidadHistorial(data.item) }}
                </template>
                <template #cell(motivo)="data">
                    {{ data.item.motivo }}
                </template>
                <template #cell(created_at)="data">
                    {{ formatearFecha(data.item.created_at) }}
                </template>
            </b-table>
        </b-modal>
        <div class="row justify-content-end">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h4 class="mb-0"> Listado de Inventario de ingrediente/productos</h4>
                            <div class="d-inline-block ml-3">
                                <button :class="windowWidth>576?'btn btn-darkpurple btn-md py-2 mr-2':'btn btn-darkpurple btn-sm py-2 mr-2'"
                                    @click="ver_modal_producto('nuevo', '')">
                                    <i class="fas fa-plus"></i> Agregar ingrediente/producto
                                </button>
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col-sm-12 col-md-6">
                                <div class="d-inline-flex align-items-center">
                                    <label class="mb-0 mr-2">Mostrar</label>
                                    <b-form-select v-model="perPage" size="sm" :options="pageOptions"></b-form-select>
                                </div>
                            </div>
                            <!-- Search -->
                            <div class="col-sm-12 col-md-6">
                                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                                    <label class="d-inline-flex align-items-center">
                                        Buscar:
                                        <b-form-input v-model="filter" type="search" placeholder="Buscar..."
                                            class="form-control form-control-sm ml-2"></b-form-input>
                                    </label>
                                </div>
                            </div>
                            <!-- End search -->
                        </div>
                        <!-- Table -->
                        <div class="table-responsive mb-0 ">
                            <b-table :items="articulos" :fields="fields" responsive="sm" :per-page="perPage"
                                :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                                :filter="filter" :filter-included-fields="filterOn" @filtered="onFiltered">
                                <template #cell(index)="data">
                                    {{ data.index + 1 }}
                                </template>
                                <template #cell(name)="data">
                                    {{ data.item.name }}
                                </template>
                                <template #cell(medida)="data">
                                    {{ data.item.medida ? data.item.medida.name : '' }}
                                </template>
                                <template #cell(stock)="data">
                                    <span style="font-size: 1em; font-weight: bold;"
                                        :class="['badge', data.item.stock <= data.item.stock_minimo ? 'badge-danger' : '']">
                                        {{ data.item.stock }} {{ codigoMedidaStock(data.item.medida) }}
                                    </span>
                                </template>
                                <template #cell(actions)="data">
                                    <div class="btn-group">
                                        <button class="btn btn-teal btn-sm py-1 px-2" @click="ver_historial(data.item)">
                                            <i class="fas fa-eye"></i>
                                        </button>
                                        <button class="btn btn-pink btn-sm py-1 px-2" v-if="data.item.stock > 0"
                                            @click="quitar_stock(data.item)">
                                            <i class="fas fa-minus"></i>
                                        </button>
                                        <button class="btn btn-purple btn-sm py-1 px-2" v-if="!['Vacuna', 'Medicamento', 'Antiparasitario'].includes(data.item.categoria ? data.item.categoria.name : '')"
                                            @click="agregar_stock(data.item)">
                                            <i class="fas fa-plus"></i>
                                        </button>

                                        <!-- <button class="btn btn-info btn-sm py-1 px-2"
                                            @click="ver_modal_producto('clonar',data.item)">
                                            <i class="fas fa-copy"></i>
                                        </button> -->
                                    </div>
                                </template>
                            </b-table>
                        </div>
                        <div class="row">
                            <div class="col">
                                <div class="dataTables_paginate paging_simple_numbers float-right">
                                    <ul class="pagination pagination-rounded mb-0">
                                        <!-- pagination -->
                                        <b-pagination v-model="currentPage" :total-rows="rows"
                                            :per-page="perPage"></b-pagination>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>
